import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { CountdownTimer } from '../CountdownTimer';
const optionOne = ['Continue jumping between multiple guidelines.', 'Search. Cross-reference. Second-guess.', 'And hope you’ve found the right answer before the patient leaves.'];
const optionTwo = ['Open Kidney Disease Route™.', 'Identify the patient’s clinical situation.', 'Follow the appropriate pathway.', 'Finding → Decision → Action → Monitoring → Referral.'];
export function FinalChoice() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-163" data-mp="2rx28dgkvgf5d">
      <div className="mx-auto max-w-4xl" data-id="element-164" data-mp="2rxbxl1y3eia0">
        <h2 className="mx-auto max-w-2xl text-balance text-center font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-165" data-mp="2my8vnqdess69">
          The next time a patient walks into your office with an elevated creatinine, you’ll have two
          choices.
        </h2>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:mt-12 lg:grid-cols-2 lg:gap-6" data-id="element-166" data-mp="l4t3gp1ob596">
          <article className="rounded-3xl border border-navy-100 bg-cream p-5 sm:p-7" data-id="element-167" data-mp="39zyuvaelcmf8">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-navy-400" data-id="element-168" data-mp="3e0sjy73rs79p">
              Option 1
            </p>
            <ul className="mt-4 space-y-3" data-id="element-169" data-mp="34yj7hboxy3to">
              {optionOne.map(item => <li key={item} className="flex gap-2.5" data-id="element-170" data-mp="3sodkbt99fsdx">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy-300" aria-hidden="true" data-id="element-171" data-mp="3sovp5e9znexg" />
                  <span className="text-[14.5px] font-medium leading-relaxed text-navy-600 sm:text-[15px]" data-id="element-172" data-mp="1grcdofid3r9">
                    {item}
                  </span>
                </li>)}
            </ul>
          </article>

          <article className="rounded-3xl border-2 border-brick-200 bg-white p-5 shadow-[0_20px_50px_-30px_rgba(8,32,60,0.5)] sm:p-7" data-id="element-173" data-mp="3nvannc96s2ti">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-brick-600" data-id="element-174" data-mp="k92a73vb2bii">
              Option 2
            </p>
            <ul className="mt-4 space-y-3" data-id="element-175" data-mp="u40ryeoaiyng">
              {optionTwo.map(item => <li key={item} className="flex gap-2.5" data-id="element-176" data-mp="p6r3p2cn0t17">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brick-600" aria-hidden="true" data-id="element-177" data-mp="k633bq2iqzub" />
                  <span className="text-[14.5px] font-semibold leading-relaxed text-navy-800 sm:text-[15px]" data-id="element-178" data-mp="g51cnxmo3w3y">
                    {item}
                  </span>
                </li>)}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-10 max-w-xl text-balance text-center font-display text-[22px] font-bold leading-snug text-navy-900 sm:text-3xl" data-id="element-179" data-mp="6ddi3nutdyy9">
          You don’t need more information. You need a better way to use the information you already
          have. You need a route.
        </p>

        <div className="mt-8" data-id="element-180" data-mp="3oj9qu0og0kcl">
          <CTAButton label="Yes — I want Kidney Disease Route™" subline="Instant digital access • One-time payment • Lifetime access • 7-day guarantee" data-id="element-181" data-mp="3ome03cgrm6a4" />
        </div>

        <div className="mt-6" data-id="element-182" data-mp="1z5s6p812c3po">
          <CountdownTimer data-id="element-183" data-mp="2420rp21xyr4r" />
        </div>
      </div>
    </section>;
}